import type { GanttPrintChromeProps } from "./types-gantt-print-chrome";
import { useGanttPrintChrome } from "./use-gantt-print-chrome";
import { GanttPrintChromeView } from "./view-gantt-print-chrome";

/** Capa do PDF: só aparece na impressão. O corpo é o Gantt já na tela. */
export function GanttPrintChrome(props: GanttPrintChromeProps) {
  const vm = useGanttPrintChrome(props);

  return <GanttPrintChromeView {...vm} />;
}

export type * from "./types-gantt-print-chrome";
